import React from 'react';
import propTypes from 'prop-types';
import Column from './Column';

const Row = ({ rowKey, columns, className }) => {
	return (
		<div className={`row ${className}`}>
			{columns.map((column, i) => {
				const keyVal = `${rowKey}-column${i}`;
				return <Column key={keyVal} {...column} />;
			})}
		</div>
	);
};

export default Row;

Row.propTypes = {
	columns: propTypes.instanceOf(Array).isRequired,
	rowKey: propTypes.string.isRequired,
	className: propTypes.string.isRequired
};
